<div class=" mt-4">
  <section>
    <div class="row">
      <div class="col-md-12">
        <div class="float-right">
          <button class="btn dash-btns mr-3" [routerLink]="['/PayOut/PayoutAccountdetails']" *ngIf="NewAccount">Payout Security
            PayOut Contact </button>
          <button class="btn dash-btns mr-3" [routerLink]="['/PayOut/managePayoutAccountdetails']">Manage Payout Security
          </button>
          <button [routerLink]="['/reports/transactions/summary']" class="dash-btns btn">Reports</button>



        </div>
      </div>
    </div>

  </section>
  <section class="mt-3">
    <div class="">
      <div class="row">
        <div class="col-md-7">
          <div class="card-1">
            <div class="row">
              <div class="col-md-12">
               
                <div class="text-center">
                  <a class="view-h gary-t  ">View Payout Security</a>
                </div>

                <div class="pt-3">
                  <div class=" ">
                    <div class="row mb-3">

                      <div class="col-4 p-0"> <label>AccountNumber</label> </div>

                      <div class="col-7 p-0 view-text robot" *ngIf="CrossAccNo"> {{Accountdetails.AccountNumber}}
                        <span color="accent" id="fullCardNo." (click)="onSelect(true)" *ngIf="CrossAccNo">
                          <i class="fab fa-sistrix"
                              style="color:#41c0e8;font-size:16px; font-weight:600;"></i>
                      </span>
                      </div>
                      <div class="col-6 p-0 view-text" *ngIf="FullAccNo"> {{FullAccountNumber}}
                    </div>
                    </div>
                    <div class="row mb-3">

                      <div class="col-4 p-0"> <label>IFSCCode</label> </div>

                      <div class="col-7 p-0 view-text robot"> {{Accountdetails.IFSCCode}}
                      </div>
                    </div>
                    <div class="row mb-3">

                      <div class="col-4 p-0"> <label>UserName</label> </div>

                      <div class="col-7 p-0 view-text robot"> {{Accountdetails.UserName}}</div>
                    </div>
                    <div class="row mb-3">

                      <div class="col-4 p-0"> <label>UpdatedDateTime</label> </div>

                      <div class="col-7 p-0 view-text"> {{Accountdetails.UpdatedDateTime | date:'d/M/yy, h:mm a' }}</div>
                    </div>
                    <!-- <div class="row mb-3">

                      <div class="col-4 p-0"> <label> UserIp</label></div>

                      <div class="col-7 p-0 view-text robot"> {{Accountdetails.UserIp}}</div>
                    </div> -->

                    <div class="row mb-3">

                      <div class="col-4 p-0"> <label>PaymentType </label> </div>

                      <div class="col-7 p-0 view-text"> {{Accountdetails.PaymentType}}</div>
                    </div>
                    <div class="row mb-3">

                      <div class="col-4 p-0"><label> UpiVPA </label> </div>

                      <div class="col-7 p-0 view-text robot"> {{Accountdetails.UpiVPA}}</div>
                    </div>
                    <div class="row mb-3">

                      <div class="col-4 p-0"> <label> ApprovalDocument </label> </div>

                      <div class="col-7 p-0 view-text"> {{Accountdetails.ApprovalDocument}}</div>
                    </div>
                    <div class="row mb-3">

                      <div class="col-4 p-0"> <label> CustomerAccountId</label> </div>

                      <div class="col-7 p-0 view-text robot"> {{Accountdetails.CustomerAccountId }}</div>
                    </div>
                    <div class="row mb-3">

                      <div class="col-4 p-0"> <label> PayoutAccountNumber</label> </div>

                      <div class="col-7 p-0 view-text robot"> {{Accountdetails.PayoutAccountNumber }}</div>
                    </div>
                    <!-- <div class="row mb-3">

                      <div class="col-4 p-0"> <label>PayoutProcessor</label> </div>

                      <div class="col-7 p-0 view-text robot"> {{Accountdetails.PayoutProcessor}}</div>
                    </div> -->
                  
                    <div class="row mb-3" *ngIf="Imageavalabel">

                      <div class="col-4 p-0 label1"> Document / proof </div>
                      <a data-bs-toggle="modal" data-bs-target="#exampleModalCenter">

                      <img [ngStyle]="{'width': maxWidth+'px', 'height': maxHeight+'px'}"
                          src="data:image/jpeg;base64,{{content}}" fxFlexAlign="center"
                          id="merchatImage"
                          class="fade-in-on-icon-sidenav img-thumbnail img-rounded">
                          </a>
                    </div>
                    
                    <div class="row mb-3" *ngIf="noImageavalabel">

                      <div class="col-4 p-0 label1"> Document / proof </div>
                      <img [ngStyle]="{'width': maxWidth+'px', 'height': maxHeight+'px'}"
                              src="assets/img/no-preview.png" fxFlexAlign="center"
                              id="merchatImage"
                              class="fade-in-on-icon-sidenav img-thumbnail img-rounded">
                    </div>
                   
                      <div class="row mb-3" *ngIf="pdffile">
                        <div class="col-4 p-0 label1"> Document / proof </div>
                        <img [ngStyle]="{'width': maxWidth+'px', 'height': maxHeight+'px'}"
                            src="assets/img/pdf.png" fxFlexAlign="center"
                            id="merchatImage" class="fade-in-on-icon-sidenav img-thumbnail img-rounded"  (click)="Viewpdf()">
    

                    </div>

                  </div>
                </div>
                <!-- <button class="btn dash-btns mr-3" id="Savecoupon" color="primary"
                (click)="DeletePayoutSecurity()">Delete Payout Security </button> -->
                <button class="btn dash-btns mr-3" [routerLink]="['/PayOut/managePayoutAccountdetails']">Back</button>

              </div>
            </div>
          </div>
        </div>
        <div class="col-md-5">
          <div class="text-center">
            <div class="card-1 p-2">
              <img src="https://fastswiff.com/assets/img/security.png" class="w-100" alt="">

            </div>
          </div>
        </div>
      </div>
   
    </div>
  </section>


  <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle"></h5>
          <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" >
          
            <img 
            src="data:image/jpeg;base64,{{content}}" fxFlexAlign="center" id="merchatImage"
            class="fade-in-on-icon-sidenav img-thumbnail img-rounded">
        </div>
      </div>
    </div>
  </div>
</div>